import { FC } from "react";
import { DatatableContextProvider } from "@/components/tables/contexts/DatatableContextProvider";
import { AIServiceDetailPageContent } from "./AIServiceDetailPageContent";

export const AIServiceDetailPage: FC = () => (
  <DatatableContextProvider>
    <AIServiceDetailPageContent />
  </DatatableContextProvider>
);
